export default {
  // 页面标题
  'pages.building.title': '楼栋管理',

  // 表格列标题
  'pages.building.table.columns.buildingName': '楼栋名称/编号',
  'pages.building.table.columns.buildingType': '楼栋类型',
  'pages.building.table.columns.floorCount': '楼层数',
  'pages.building.table.columns.unitCount': '单元数',
  'pages.building.table.columns.totalUnits': '总户数',
  'pages.building.table.columns.elevatorCount': '电梯数量',
  'pages.building.table.columns.buildingArea': '建筑面积(㎡)',
  'pages.building.table.columns.buildingHeight': '建筑高度(m)',
  'pages.building.table.columns.constructionYear': '建设年份',
  'pages.building.table.columns.completionYear': '竣工年份',
  'pages.building.table.columns.project': '项目',
  'pages.building.table.columns.operations': '操作',

  // 按钮文本
  'pages.building.buttons.view': '查看',
  'pages.building.buttons.edit': '编辑',
  'pages.building.buttons.delete': '删除',
  'pages.building.buttons.create': '新建楼栋',
  'pages.building.buttons.batchDelete': '批量删除',
  'pages.building.buttons.close': '关闭',
  'pages.building.buttons.update': '更新',
  'pages.building.buttons.createBtn': '创建',

  // 模态框标题
  'pages.building.modal.createTitle': '新建楼栋',
  'pages.building.modal.editTitle': '编辑楼栋',
  'pages.building.modal.detailTitle': '楼栋详情',

  // 确认对话框
  'pages.building.confirm.delete': '确定要删除这个楼栋吗？',
  'pages.building.confirm.batchDelete': '确定要批量删除选中的楼栋吗？',
  'pages.building.confirm.okText': '确定',
  'pages.building.confirm.cancelText': '取消',

  // 表格选择提示
  'pages.building.table.selection.selected': '已选择',
  'pages.building.table.selection.items': '项',
  'pages.building.table.selection.cancel': '取消选择',

  // 成功/失败消息
  'pages.building.message.loadTypeFailed': '获取楼栋类型失败',
  'pages.building.message.getDetailFailed': '获取楼栋详情失败',
  'pages.building.message.deleteSuccess': '删除成功',
  'pages.building.message.deleteFailed': '删除失败',
  'pages.building.message.batchDeleteSuccess': '批量删除成功',
  'pages.building.message.batchDeleteFailed': '批量删除失败',
  'pages.building.message.createSuccess': '创建成功',
  'pages.building.message.updateSuccess': '更新成功',
  'pages.building.message.createFailed': '创建失败',
  'pages.building.message.updateFailed': '更新失败',

  // 详情描述标签
  'pages.building.detail.label.buildingName': '楼栋名称/编号',
  'pages.building.detail.label.buildingType': '楼栋类型',
  'pages.building.detail.label.floorCount': '楼层数',
  'pages.building.detail.label.unitCount': '单元数',
  'pages.building.detail.label.totalUnits': '总户数',
  'pages.building.detail.label.elevatorCount': '电梯数量',
  'pages.building.detail.label.buildingArea': '建筑面积(㎡)',
  'pages.building.detail.label.buildingHeight': '建筑高度(m)',
  'pages.building.detail.label.constructionYear': '建设年份',
  'pages.building.detail.label.completionYear': '竣工年份',
  'pages.building.detail.label.createdTime': '创建时间',
  'pages.building.detail.label.updatedTime': '更新时间',
  'pages.building.detail.label.project': '项目',
  'pages.building.detail.label.remarks': '备注',

  // 表单字段标签
  'pages.building.form.label.buildingName': '楼栋名称/编号',
  'pages.building.form.label.buildingType': '楼栋类型',
  'pages.building.form.label.floorCount': '楼层数',
  'pages.building.form.label.unitCount': '单元数',
  'pages.building.form.label.totalUnits': '总户数',
  'pages.building.form.label.elevatorCount': '电梯数量',
  'pages.building.form.label.buildingHeight': '建筑高度(米)',
  'pages.building.form.label.buildingArea': '建筑面积',
  'pages.building.form.label.constructionYear': '建设年份',
  'pages.building.form.label.completionYear': '竣工年份',
  'pages.building.form.label.project': '项目',
  'pages.building.form.label.remarks': '备注',

  // 表单占位符
  'pages.building.form.placeholder.buildingName': '请输入楼栋名称或编号',
  'pages.building.form.placeholder.buildingType': '请选择楼栋类型',
  'pages.building.form.placeholder.floorCount': '请输入楼层数',
  'pages.building.form.placeholder.unitCount': '请输入单元数',
  'pages.building.form.placeholder.totalUnits': '请输入总户数',
  'pages.building.form.placeholder.elevatorCount': '请输入电梯数量',
  'pages.building.form.placeholder.buildingHeight': '请输入建筑高度',
  'pages.building.form.placeholder.buildingArea': '请输入建筑面积',
  'pages.building.form.placeholder.constructionYear': '请输入建设年份',
  'pages.building.form.placeholder.completionYear': '请输入竣工年份',
  'pages.building.form.placeholder.project': '请选择项目',
  'pages.building.form.placeholder.remarks': '请输入备注信息',

  // 表单验证消息
  'pages.building.form.validation.buildingNameRequired': '请输入楼栋名称/编号',
  'pages.building.form.validation.buildingNameMaxLength': '楼栋名称长度不能超过100个字符',
  'pages.building.form.validation.buildingTypeRequired': '请选择楼栋类型',
  'pages.building.form.validation.floorCountRequired': '请输入楼层数',
  'pages.building.form.validation.floorCountMin': '楼层数不能小于1',
  'pages.building.form.validation.unitCountMaxLength': '单元数长度不能超过10个字符',
  'pages.building.form.validation.totalUnitsMaxLength': '总户数长度不能超过10个字符',
  'pages.building.form.validation.elevatorCountMaxLength': '电梯数量长度不能超过10个字符',
  'pages.building.form.validation.buildingHeightMaxLength': '建筑高度长度不能超过20个字符',
  'pages.building.form.validation.buildingAreaMaxLength': '建筑面积长度不能超过20个字符',
  'pages.building.form.validation.constructionYearMaxLength': '建设年份长度不能超过10个字符',
  'pages.building.form.validation.constructionYearPattern': '请输入有效的年份格式(如:2023)',
  'pages.building.form.validation.completionYearMaxLength': '竣工年份长度不能超过10个字符',
  'pages.building.form.validation.completionYearPattern': '请输入有效的年份格式(如:2023)',
  'pages.building.form.validation.remarksMaxLength': '备注长度不能超过500个字符',

  // 单位
  'pages.building.units.floor': '层',
  'pages.building.units.unit': '个',
  'pages.building.units.household': '户',
  'pages.building.units.elevator': '台',
  'pages.building.units.meter': 'm',
};
